import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import type { DisplayConditionsValue } from '../../components/smart-cart-form-display-conditions/display-conditions.model';
import type { GoalDefault } from './goals-progress-bar.model';

export const AUTO_APPLIED_ORDER_DISCOUNT_WITH_DISPLAY_CONDITIONS_ERROR =
  'autoAppliedOrderDiscountWithDisplayConditions';

export interface GoalsProgressBarAutoApplyCheckInput {
  goals?: Pick<GoalDefault, 'enabled' | 'offer'>[];
  displayConditions?: DisplayConditionsValue;
}

export function findAutoAppliedOrderDiscountGoalIndexesLimitedByDisplayConditions(
  goalsProgressBarSettings: GoalsProgressBarAutoApplyCheckInput,
): number[] {
  const hasDisplayConditions = (goalsProgressBarSettings.displayConditions?.rules ?? []).length > 0;
  if (!hasDisplayConditions) return [];
  return (goalsProgressBarSettings.goals ?? []).flatMap((goal, goalIndex) =>
    goal.enabled !== false && goal.offer?.type === 'orderDiscount' && goal.offer.orderDiscount?.autoApply === true
      ? [goalIndex]
      : [],
  );
}

export function createAutoAppliedOrderDiscountWithDisplayConditionsValidator(
  isGoalsProgressBarEnabled: () => boolean,
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!isGoalsProgressBarEnabled()) return null;
    const blockedGoalIndexes = findAutoAppliedOrderDiscountGoalIndexesLimitedByDisplayConditions(control.getRawValue());
    return blockedGoalIndexes.length
      ? { [AUTO_APPLIED_ORDER_DISCOUNT_WITH_DISPLAY_CONDITIONS_ERROR]: blockedGoalIndexes }
      : null;
  };
}
